import { Component } from 'react';
import Selector from './Selector';
import {
  getAllActiveDishtypes,
  getCustomerDishtypes,
  updateCustomerDishtypes,
  getDishtypes,
} from '../api/api';
import { createSelectorOptions } from '../utils/utils';
import PropTypes from 'prop-types';

class DishtypePreferences extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRecipes: [],
      dishtypesOptions: {},
    };
  }

  componentDidMount() {
    if (this.props.notSurvey) {
      getDishtypes()
        .then((data) => {
          this.setState({
            dishtypesOptions: createSelectorOptions(
              data,
              'id',
              'name',
              'profile_image'
            ),
          });
          return getCustomerDishtypes();
        })
        .then((data) => {
          this.setState({ selectedRecipes: data.dishtypes });
        })
        .then(() => this.passDataToParent())
        .catch(console.error);
    } else {
      getAllActiveDishtypes()
        .then((data) => {
          this.setState({ dishtypesOptions: data });
          return getCustomerDishtypes();
        })
        .then((data) => {
          this.setState({ selectedRecipes: data.dishtypes });
        })
        .then(() => this.passDataToParent())
        .catch(console.error);
    }
  }

  updatePrefs(val) {
    let rating = this.state.selectedRecipes.includes(val) ? 0 : 1;
    return updateCustomerDishtypes(val, rating).then(({ id }) => {
      rating === 0
        ? this.setState(
            {
              selectedRecipes: this.state.selectedRecipes.filter(
                (d) => d !== id
              ),
            },
            () => this.passDataToParent()
          )
        : this.setState(
            { selectedRecipes: [...this.state.selectedRecipes, id] },
            () => this.passDataToParent()
          );
    });
  }

  passDataToParent() {
    if (this.props.onChange) {
      this.props.onChange(
        this.state.selectedRecipes,
        this.state.dishtypesOptions
      );
    }
  }

  render() {
    return (
      <Selector
        selected={this.state.selectedRecipes}
        options={this.state.dishtypesOptions}
        action={(val) => this.updatePrefs(val)}
        actionIsPromise={true}
      />
    );
  }
}

DishtypePreferences.propTypes = {
  onChange: PropTypes.func,
  notSurvey: PropTypes.bool,
};

export default DishtypePreferences;
